import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _TransversalSkillType } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { TransversalSkillLevel } from "../TransversalSkillLevel/TransversalSkillLevel";
// import { Submacroprocces } from "./Submacroprocces";



export const TransversalSkillType = () => {

    const TransversalSkillType = useDataBean(_TransversalSkillType);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modalsubprocces, setModalsubprocces] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        TransversalSkillType.instance.getTransversalSkillTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        TransversalSkillType.setBean({

        });
        setModal({ ...modal, "name": "Niveles Jerárquicos", "view": true });
    }

    const deleteItem = () => {
        TransversalSkillType.instance.deleteTransversalSkillType(TransversalSkillType.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
       //console.log(TransversalSkillType.bean);
        TransversalSkillType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTransversalSkillType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: ' Niveles Jerárquicos', icono: 'ri-file-user-line', visible: true, evento: () => { setModalsubprocces({ ...modalsubprocces, "name": `${TransversalSkillType.bean.Name} `, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo=" Tipo de Competencias Transversales ">
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={TransversalSkillType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={TransversalSkillType.bean.Name} onChange={TransversalSkillType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-12">
                                <label>Description</label>
                                <textarea name="Description" className="form-control" value={TransversalSkillType.bean.Description} onChange={TransversalSkillType.handleChange} />
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={modalsubprocces} updateModal={setModalsubprocces} eventModal={editaItem}>
                        <TransversalSkillLevel IDTransversalSkillType={TransversalSkillType.bean.IDTransversalSkillType} />

                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}